var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M26.385 13.5c0 7.182-5.797 13-12.942 13C6.297 26.5.5 20.682.5 13.5S6.297.5 13.443.5s12.942 5.818 12.942 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M8.904 8.904l9.192 9.192m-9.192 0l9.192-9.192"
  })));
}

var MemoSvgClose = /*#__PURE__*/React.memo(SvgClose);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyNyAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjM4NTEgMTMuNUMyNi4zODUxIDIwLjY4MTcgMjAuNTg4NSAyNi41IDEzLjQ0MjYgMjYuNUM2LjI5NjU5IDI2LjUgMC41MDAwMDQgMjAuNjgxNyAwLjUwMDAwMiAxMy41QzAuNTAwMDAxIDYuMzE4MjkgNi4yOTY1OSAwLjQ5OTk5OSAxMy40NDI2IDAuNDk5OTk4QzIwLjU4ODUgMC40OTk5OTYgMjYuMzg1MSA2LjMxODI4IDI2LjM4NTEgMTMuNVoiIHN0cm9rZT0iIzJDMjY2NCIvPgo8cGF0aCBkPSJNOC45MDM4MSA4LjkwMzgxTDE4LjA5NjIgMTguMDk2MiIgc3Ryb2tlPSIjMkMyNjY0IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTguOTAzODEgMTguMDk2MkwxOC4wOTYyIDguOTAzOCIgc3Ryb2tlPSIjMkMyNjY0IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { MemoSvgClose as ReactComponent };